export const actionChangeDataModalPwaIsIos = (name,value) => ({
    type: 'CHANGE_STATUS_DATA_MODAL_PWA_IS_IOS',name,value
});